module.exports = __webpack_public_path__ + "static/media/results-hero-wheel.e5c156a5.gif";